import * as React from 'react';

type Props = {
  warnings: string[];
};

export function RootWarnings({ warnings }: Props) {
  if (warnings.length === 0) return null;
  return (
    <div
      className="flex flex-col items-end gap-1 text-sm text-amber-700"
      data-testid="line-item-warnings">
      {warnings.map((msg, i) => (
        <div key={i}>{msg}</div>
      ))}
    </div>
  );
}
